import { Step, StepType } from '@/dashboard/types/step';
import { ProjectApi } from '@/dashboard/api/project';
import { useProjectAddAndEdit } from '@/dashboard/store/projectAddEditPopupStore';
import { WorkspaceApi } from '@/dashboard/api/workspace';

export async function openEditProject(shortLink: string, step: StepType = Step.Name) {
  const projectAddAndEdit = useProjectAddAndEdit();

  const project = (await ProjectApi.getByShortLink(shortLink)).project;
  const workspace = (await WorkspaceApi.getById(project?.workspace_id ?? 0)).workspace;

  if (project && workspace) {
    projectAddAndEdit.openPopup(workspace, project, step);
  }
}
